import { ProgressBar, Tooltip } from '@infl-ts/ui-advocate-components';
import { useChallengePlayer } from '@infl-ts/util-use-challenge-player';
import CloseIcon from '@mui/icons-material/Close';
import { AppBar, Box, Button, IconButton, Typography } from '@mui/material';
import { flow } from 'fp-ts/function';
import { Translation } from 'react-i18next';
import { Header } from './challenge-header';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";

var EmptyHeader = function EmptyHeader(_ref) {
  var onClose = _ref.onClose;
  return /*#__PURE__*/_jsxs(AppBar, {
    sx: {
      boxShadow: 'none'
    },
    color: "transparent",
    position: "sticky",
    "data-element": "AppBar",
    "data-component": "EmptyHeader",
    "data-source-file": "loading-error.tsx",
    children: [/*#__PURE__*/_jsx(Header, {
      sx: {
        p: 2,
        display: 'flex',
        flexDirection: 'row-reverse',
        alignItems: 'center'
      },
      "data-element": "Header",
      "data-component": "EmptyHeader",
      "data-source-file": "loading-error.tsx",
      children: /*#__PURE__*/_jsx(Translation, {
        "data-element": "Translation",
        "data-component": "EmptyHeader",
        "data-source-file": "loading-error.tsx",
        children: function children(t) {
          return /*#__PURE__*/_jsx(Tooltip, {
            title: t('Close'),
            children: /*#__PURE__*/_jsx(IconButton, {
              onClick: onClose,
              children: /*#__PURE__*/_jsx(CloseIcon, {})
            })
          });
        }
      })
    }), /*#__PURE__*/_jsx(ProgressBar, {
      progress: 0,
      "data-element": "ProgressBar",
      "data-source-file": "loading-error.tsx"
    })]
  });
};

var LoadingError = function LoadingError(_ref2) {
  var onClose = _ref2.closeChallengePlayer;
  return /*#__PURE__*/_jsx(Translation, {
    "data-element": "Translation",
    "data-component": "LoadingError",
    "data-source-file": "loading-error.tsx",
    children: function children(t) {
      return /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(EmptyHeader, {
          onClose: onClose
        }), /*#__PURE__*/_jsxs(Box, {
          sx: {
            py: {
              xs: 3,
              md: 5
            },
            mx: 'auto',
            px: 2.5,
            mt: 18,
            maxWidth: 385,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center'
          },
          children: [/*#__PURE__*/_jsx(Typography, {
            variant: "h3",
            sx: {
              textAlign: 'center',
              mb: 1
            },
            children: t('Challenge not found')
          }), /*#__PURE__*/_jsx(Typography, {
            sx: {
              textAlign: 'center'
            },
            children: t('We couldn’t load this because it may no longer be available or because of an error.')
          }), /*#__PURE__*/_jsx(Button, {
            onClick: onClose,
            variant: "contained",
            sx: {
              mt: 3
            },
            children: t('Close challenge')
          })]
        })]
      });
    }
  });
};

var useProps = function useProps() {
  return useChallengePlayer();
};

export default Object.assign(flow(useProps, LoadingError), {
  displayName: 'LoadingError'
});